import { css, cva } from '@/styled-system/css';

export const containerStyles = cva({
  variants: {
    isFixedPosition: {
      true: {
        background: 'white',
        borderBottom: '{borderWidths.25} solid {colors.gray.300}',
        padding: '400',

        position: 'fixed',
        zIndex: 'loadingMask',
        top: 0,
        right: 0,
        left: { base: 0, xxl: '{sizes.leftNavWidth}' },
        width: { base: '100%', xxl: 'calc(100% - {sizes.leftNavWidth})' },
        animation: 'fadeIn linear 0.2s',
      },
    },
  },
});

export const pageContentStyles = css.raw({
  margin: '0 auto',
  padding: '0',
  maxWidth: '1220px',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: { base: 'column', md: 'row' },
});
